import { createContext } from 'react';

import { TChatComposerFocusContextValue } from './types';

const ChatComposerFocusContext = createContext<TChatComposerFocusContextValue>({
  focusMessageInput: () => undefined,
  hasDraft: false,
});

export { ChatComposerFocusContext };
